import React from "react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "../shared/layout";
import { SharedItemsList } from "@/components/share/shared-items-list";

export function SharedInboxScreen() {
  const { t } = useTranslation();
  
  return (
    <AppLayout
      title={t("sharedInbox.title")}
      description={t("sharedInbox.subtitle")}
    >
      <div className="max-w-3xl mx-auto">
        <SharedItemsList />
      </div>
    </AppLayout>
  );
}
